import styled, { css } from 'styled-components';

import { BannerContainerProps } from 'organisms/banners/Banner.landing.styles';
import { layout } from 'styles/layout';
import { palette } from 'styles/colors';

interface BannerBackgroundProps {
  removeConfetti?: boolean;
}

export const BannerBackground = styled.div<BannerBackgroundProps>`
  background: ${palette.mightyProLight};
  max-width: 100vw !important;
  width: 100vw !important;
  padding: 4em 0rem 5em 0rem;
  position: relative;
  overflow: hidden;
  margin-top: -2px !important;

  ${({ removeConfetti }) => removeConfetti ? '' : css`
    @media screen and (min-width: ${layout.subLg}) {
      background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTE2IiBoZWlnaHQ9IjE5OCIgdmlld0JveD0iMCAwIDExNiAxOTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04Ni45OTggNzkuOTU0MUw5NS43NjE5IDkxLjY2NjRMMTA0LjA5NSA5Mi45MDQ3TDExNS43OTMgODQuMjMzTDEwNy4xMjIgNzIuNTM0NUw5OC43ODg5IDcxLjI5NjNMODYuOTk4IDc5Ljk1NDFaIiBmaWxsPSIjMUNBQkJGIi8+CjxwYXRoIGQ9Ik0zNy44MjI1IDE4MS4zMjlMMTguMjc1NiAxOTUuODg4TDIwLjcxOSAxNzguODcyTDM3LjgyMjUgMTgxLjMyOVoiIHN0cm9rZT0iI0ZGREY2RSIgc3Ryb2tlLXdpZHRoPSIxLjQ0MDQ2IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xLjk5ODAxIDI5LjU2NDdMMjYuMDU2OSAxOC4wMDI1TDI0LjIzMDEgNS42MjY5TDE2Ljg1NTUgMS42OTU4TDEuOTk4MDEgMjkuNTY0N1oiIHN0cm9rZT0iI0ZGNzA2MiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=) 82% 31% no-repeat ${palette.mightyProLight};
    }
  `}

  &:after {
    content: "";
    background-color: ${palette.white};
    height: 100px;
    width: 110%;
    left: -25px;
    bottom: -50px;
    position: absolute;
    transform: rotate(3deg);

    @media screen and (min-width: ${layout.xlg}) {
      transform: rotate(1deg);
    }
  }
`

export const BannerProContainer = styled.div<BannerContainerProps>`
  max-width: 1220px !important;
  column-gap: 0rem;
  display: grid;
  justify-self: center;
  box-sizing: border-box;
  position: relative;
  margin: 0 auto;

  grid-template-columns: 1fr 15% 370px;

  @media all and (max-width: ${layout.subLg}) {
    grid-template-columns: 1fr 15% 316px;
  }

  @media all and (max-width: ${layout.subMd}) {
    grid-template-columns: 1fr;
  }

  h1 {
    @media screen and (min-width: ${layout.lg}) {
      font-size: 54px;
    }
  }

  a {
    font-size: 16px;
    line-height: 1.25;
    margin: 0 24px 0 0;
    background-color: ${palette.proBlue};
    min-width: 206px;
  }

  button {
    color: ${palette.proBlue};
  }

  svg {
    fill: ${palette.proBlue};
  }
`;

export const BannerImage = styled.div`
  max-width: 360px;
  justify-self: center;
  grid-area: home-phone;
  grid-column: 2 / 4;
  grid-row: 1 / 2;

  @media all and (max-width: ${layout.subMd}) {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
  }
  @media all and (max-width: ${layout.xs}) {
    max-width: 100%;
  }
`;

export const BannerProText = styled.div`
  display: grid;
  align-self: center;
  grid-column: 1 / 3;
  grid-row: 1 / 2;
  max-width: 635px;
  margin-left: 10%;

  & > div {
    row-gap: 0.5rem;
    grid-area: unset;

    @media all and (max-width: ${layout.subMd}) {
      max-width: 100%;
    }

    & > div {
      margin-top: 1rem;
      grid-template-columns: 256px 180px;

      a {
        margin-right: 0rem;
      }

      @media all and (max-width: ${layout.subLg}) {
        grid-template-columns: 256px;
        justify-self: center;
        row-gap: 1rem;

        button {
          justify-self: center;
          grid-row: 2;
        }

        a {
          grid-row: 1;
        }
      }
    }
  }

  @media all and (max-width: ${layout.lg}) {
    margin-left: 10%;
    width: 530px;
    max-width: calc(100% - 15%);
  }

  @media all and (max-width: ${layout.subLg}) {
    margin-left: 10%;
    width: 470px;
    max-width: calc(100% - 18%);

    p {
      padding-right: 0px;
    }
  }

  @media all and (max-width: ${layout.subMd}) {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
    width: auto;
    max-width: 100%;
    margin-left: 0px;
    padding: 0px 1.25rem;

    h1, p {
      text-align: center;
    }
  }
`
